import { createContext } from 'react';

export const LibraryContext = createContext<{
  disableExternalLinkModal: boolean;
  reportError: typeof console.error;
}>({
  disableExternalLinkModal: false,
  // eslint-disable-next-line no-console
  reportError: console.error,
});
